import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

import userInfoStore from './userInfo/userInfo';
import repoStore from './repo/repo';
import calendarStore from './calendar/calendarStore';
import {objectifyArr} from "@/codeFunctions";

const store = new Vuex.Store({
    modules: {userInfo: userInfoStore, repo: repoStore, cal: calendarStore},
    state() {
        return {
            placeholder: false,
            localData: null,
            getTaskHeaderFn: null,
            loggedIn: false,
            oPlugIgnore: false,
            showChat: false
        }
    },
    mutations: {
        setLocalData(state, payload) {
            state.localData = payload.value
        },
        setGetTaskHeaderFn(state, payload) {
            state.getTaskHeaderFn = payload
        },
        loggedIn(state, payload) {
            state.loggedIn = payload
        }
    },
    actions: {
        setLocalData(context, payload) {
            context.commit('setLocalData', {value: payload})
        },
        setGetTaskHeaderFn(context, payload) {
            context.commit('setGetTaskHeaderFn', payload)
        },
        setLoggedIn(context, payload) {
            context.commit('loggedIn', payload)
        },
    },
    getters: {
        loggedIn(state) {
            return state.loggedIn
        },
        getTaskHeader(state) {
            return state.getTaskHeaderFn
        },
        localData(state) {
            return state.localData;
        },
        users(state) {
            class User {
                constructor(obj) {
                    Object.assign(this, obj)
                }
                get fullName() {
                    return `${this.name} ${this.surname}`.trim();
                }
                get initials() {
                    return this.fullName.split(' ').map(str => {return str.substr(0,1)}).join('')
                }
            }
            try {
                return state.localData.users.map(user => {return new User(user)})
            } catch (e) {
                return []
            }
        },
        usersRef(state, getters) {
            return objectifyArr(getters.users, 'userID')
        },

        foldersRef(state) {
            try {
                return objectifyArr(state.localData.folders, 'id')
            } catch (e) {
                return null
            }
        },

        userGroups(state, getters) {
            class UserGroup {
                constructor(obj) {
                    Object.assign(this, obj)
                }
                get usersVal() {
                    return (this.users || [])
                        .map(userID => {
                            return getters.usersRef[userID]
                        })
                }
                get memberNames() {
                    return this.usersVal.map(user => {return user.fullName})
                }
            }
            try {
                return state.localData.userGroups.map(userGroup => {return new UserGroup(userGroup)})
            } catch (e) {
                return []
            }
        },
        userGroupsRef(state, getters) {
            return objectifyArr(getters.userGroups, 'id')
        },

        usersAndGroups(state, getters) {
            return getters.userGroups
                .map((obj) => {
                    return {
                        type: 'group',
                        description: obj.description,
                        icon: "people",
                        color: "light-blue",
                        id: obj.id,
                        refID: `g-${obj.id}`,
                        disabled: false,
                        ref: obj
                    }
                })
                .concat(getters.users.map((obj => {
                    return {
                        type: 'user',
                        description: obj.fullName || obj.username,
                        icon: "person",
                        color: obj.disabled ? 'grey' : 'cyan',
                        id: obj.userID,
                        refID: `u-${obj.userID}`,
                        ref: obj
                    }
                })))
                .sort((a, b) => a.description > b.description ? 1 : -1)
        }
    },
});

export default store


